module.exports = __webpack_public_path__ + "static/media/oracle.c00bdcb6.svg";